module.exports = __webpack_public_path__ + "static/inviteBtn.6cce14e2.png";